import React from 'react';
import PropTypes from 'prop-types';
import { BrandLine } from '@scotia/canvas-react';
import { Alignment } from '../Alignment';

/** Displays a BrandLine to divide two sections */
export const Divider = ({ align }) => (
  <Alignment lg={align} md={align} sm={align} xs={align}>
    <div style={{ display: 'inline-block' }}>
      <BrandLine />
    </div>
  </Alignment>
);

Divider.propTypes = {
  /** The horizontal position of the BrandLine */
  align: PropTypes.oneOf(['center', 'left', 'right'])
};
Divider.defaultProps = {
  align: 'center'
};
